import {DiffStats} from '@github-ui/diffs/DiffStats'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {pullRequestsLayoutRoute} from '../routes/layout-route'

export function DiffStat({hideSquares, className, bold}: {hideSquares?: boolean; className?: string; bold?: boolean}) {
  const {data} = useRouteQuery(pullRequestsLayoutRoute, 'diffstat')

  if (!data || !data.diffstat) {
    return null
  }

  const {diffstat} = data

  return (
    <DiffStats
      linesAdded={diffstat.linesAdded}
      linesDeleted={diffstat.linesDeleted}
      linesChanged={diffstat.linesChanged}
      hideSquares={hideSquares}
      className={className}
      bold={bold}
    />
  )
}
